/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Images
import officeImage from "assets/images/compromise.jpg";

const services = [
  {
    icon: "badge",
    title: "Gestión Laboral",
    description:
      "Nóminas, contratos, altas y bajas de trabajadores, Seguridad Social y relaciones laborales.",
  },
  {
    icon: "calculate",
    title: "Gestión Contable",
    description:
      "Contabilidad empresarial, estados financieros, análisis económico y cuentas anuales.",
  },
  {
    icon: "account_balance",
    title: "Asesoría Fiscal",
    description:
      "Declaraciones de IRPF, IVA, Impuesto de Sociedades, planificación y optimización tributaria.",
  },
  {
    icon: "local_shipping",
    title: "Autorizaciones de Transportes",
    description:
      "Autorizaciones, visados, renovaciones y gestiones ante la DGT para el sector transporte.",
  },
];

function Information() {
  return (
    <MKBox component="section" py={6} id="servicios">
      <Container>
        <MKBox textAlign="center" mb={6}>
          <MKTypography variant="h2" mb={1}>
            Nuestros Servicios
          </MKTypography>
          <MKTypography variant="body1" color="text" sx={{ maxWidth: 600, mx: "auto" }}>
            Soluciones integrales para particulares, autónomos y empresas
          </MKTypography>
        </MKBox>

        <MKBox
          borderRadius="xl"
          overflow="hidden"
          mb={4}
          sx={{
            maxHeight: "300px",
            width: "100%",
          }}
        >
          <img
            src={officeImage}
            alt="Oficina de Gestoría Moreno en Granada"
            width="1200"
            height="300"
            loading="lazy"
            style={{
              width: "100%",
              height: "300px",
              objectPosition: "center 42%",
              objectFit: "cover",
              borderRadius: "inherit",
            }}
          />
        </MKBox>

        <MKBox
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "2fr 1fr" },
            gap: 4,
          }}
        >
          <Grid container spacing={3}>
            {services.map(({ icon, title, description }) => (
              <Grid item xs={12} sm={6} key={title}>
                <MKBox
                  p={3}
                  borderRadius="xl"
                  shadow="md"
                  bgColor="white"
                  height="100%"
                  display="flex"
                  flexDirection="column"
                  sx={{
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <MKTypography variant="h3" component="span" color="info" textGradient mb={1}>
                    <Icon>{icon}</Icon>
                  </MKTypography>
                  <MKTypography variant="h5" component="h3" mb={1}>
                    {title}
                  </MKTypography>
                  <MKTypography variant="body2" color="text" mb={2} sx={{ flex: 1 }}>
                    {description}
                  </MKTypography>
                  {/* <MKTypography
                      component={Link}
                      to={route}
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        textDecoration: "none",
                        color: "#A75600",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      Más información&nbsp;
                      <Icon sx={{ fontSize: "1rem !important" }}>arrow_forward</Icon>
                    </MKTypography> */}
                </MKBox>
              </Grid>
            ))}
          </Grid>

          <MKBox
            bgColor="grey-100"
            borderRadius="xl"
            p={4}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            sx={{ backgroundColor: "#f8f9fa" }}
          >
            <MKBox textAlign="center" mb={3}>
              <Icon color="info" sx={{ fontSize: "2.5rem !important" }}>
                schedule
              </Icon>
              <MKTypography variant="h5" component="p" mt={1} mb={0.5}>
                Horario de atención
              </MKTypography>
              <MKTypography variant="body2" color="text">
                Lunes a Jueves
              </MKTypography>
              <MKTypography variant="body2" color="text" fontWeight="bold">
                8:30 - 14:30 y 17:00 - 19:00
              </MKTypography>
              <MKTypography variant="body2" color="text">
                Viernes
              </MKTypography>
              <MKTypography variant="body2" color="text" fontWeight="bold">
                8:00 - 15:00
              </MKTypography>
            </MKBox>

            <MKBox textAlign="center" mb={3}>
              <Icon color="info" sx={{ fontSize: "2.5rem !important" }}>
                phone
              </Icon>
              <MKTypography variant="h5" component="p" mt={1} mb={0.5}>
                Llámanos
              </MKTypography>
              <MKTypography
                component="a"
                href="tel:+34958805110"
                variant="h6"
                color="info"
                sx={{
                  color: "#A75600",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                958 805 110
              </MKTypography>
            </MKBox>

            <MKBox textAlign="center" mb={3}>
              <MKTypography variant="body2" color="text" fontStyle="italic">
                &ldquo;Haznos tu consulta sin compromiso.&rdquo;
              </MKTypography>
            </MKBox>

            <MKButton
              component="a"
              href="#contacto"
              variant="gradient"
              color="info"
              fullWidth
              size="large"
              sx={{
                textTransform: "none",
                borderRadius: "25px",
                fontWeight: 600,
              }}
            >
              Contactar ahora
            </MKButton>
          </MKBox>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default Information;
